import request from '@/util/http'
import qs from 'qs'

// 权责列表查询
export const getDutyList=(params)=>request({
    url: '/admin/charge/page',
    method: 'get',
    params
})

// 权责单个删除
export const handleDutyDelete=(id)=>request({
    url: `/admin/charge/delete/${id}`,
    method: 'delete'
})
// 权责信息
export const getDutyInfo=(id)=>request({
    url: `/admin/charge/get/${id}`,
    method: 'get'
})


// 保存权责
export const hallSaveOrUpdate=(data)=>request({
        headers:{
            "Content-Type": "application/json"
        },
        url: '/admin/charge/saveOrUpdate',
        method: 'post',
        data:JSON.stringify(data)
    })
